import { MacroEventSignal } from '../types';

export interface MacroEventResponse {
  success: boolean;
  data: MacroEventSignal[];
  latest?: MacroEventSignal | null;
  count: number;
  source?: string;
}

export async function fetchMacroEventSignals(params?: {
  limit?: number;
  shock_level?: string;
  event_type?: string;
}): Promise<MacroEventResponse> {
  const query = new URLSearchParams();
  if (params?.limit) query.set('limit', params.limit.toString());
  if (params?.shock_level) query.set('shock_level', params.shock_level);
  if (params?.event_type) query.set('event_type', params.event_type);

  try {
    const res = await fetch(`/api/macro/event-signals?${query.toString()}`, {
      headers: { 'Accept': 'application/json' }
    });
    if (!res.ok) {
      throw new Error(`Failed to fetch macro event signals: ${res.statusText}`);
    }
    return await res.json();
  } catch (err: any) {
    console.warn('[macroEventService] Fetch error, returning fallback:', err.message);
    return {
      success: true,
      data: [getDefaultMacroShock()],
      latest: getDefaultMacroShock(),
      count: 1,
      source: 'client_fallback'
    };
  }
}

export function getDefaultMacroShock(): MacroEventSignal {
  return {
    id: 'US_CPI_2026-10-14',
    event_type: 'CPI',
    market: 'US',
    release_date: '2026-10-14',
    release_time: '08:30:00',
    actual_value: 3.6,
    consensus_value: 3.2,
    previous_value: 3.1,
    surprise_delta: 0.4,
    surprise_pct: 12.5,
    shock_level: 'CRITICAL',
    affected_sectors: ['빅테크', '반도체', '성장주', '바이오'],
    portfolio_guidance: 'HEDGE_REQUIRED',
    market_reaction: {
      nasdaq_futures: -2.35,
      sp500_futures: -1.68,
      vix: 22.8,
      us10y: 4.48,
      description: '미국 헤드라인 CPI가 예상치를 +0.4%p 대폭 상회하여 긴축 장기화 우려로 증시 전반에 매도세가 집중되었습니다.'
    },
    summary: '🚨 [CPI 극심한 충격] 발표치(3.6%)가 컨센서스(3.2%)를 +0.4%p 대폭 상회했습니다. 인플레이션 고착화 및 연준의 고금리 장기화 우려로 기술주 및 고BETA 자산의 급격한 밸류에이션 조정이 진행 중입니다. 인버스/VIX 헤지 또는 현금 확보가 권고됩니다.'
  };
}
